import ViiluFullPageDialog from 'ui/components/ViiluFullPageDialog'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { CircularProgress } from 'react-md'
import { paymentFormHeaders, paymentFormTableHeaders } from './constants'
import { FormProvider, useForm } from 'react-hook-form'
import { useZodValidationResolver } from 'util/hooks/useZodValidationResolver'
import { PaymentFormSchema } from './validation'
import type { PaymentFormInputs } from './validation'
import { CreateFormGrid } from 'ui/ManagerFinance/components'
import PaymentFormInput from './PaymentFormInput'
import {
	DataTable,
	TableBody,
	TableColumn,
	TableHeader,
	TableRow,
} from 'react-md'
import { TableContainer } from 'ui/StyledComponents/Tables'
import styled from 'styled-components'

const StyledDataTable = styled(DataTable)`
	max-height: calc(100vh - 400px);
	td {
		white-space: nowrap;
	}
`

type Props = {
	refresh: () => void
	onHide: () => void
}

const PaymentDialog = ({
	//refresh,
	onHide,
}: Props) => {
	const intl = useIntl()

	const resolver =
		useZodValidationResolver<PaymentFormInputs>(PaymentFormSchema)

	const formMethods = useForm<PaymentFormInputs>({
		resolver,
		defaultValues: {},
		mode: 'onBlur',
		shouldUnregister: false,
	})

	const [processing, setProcessing] = useState(false)

	const onProcess = async () => {
		setProcessing(true)
		setProcessing(false)
	}

	const renderTableHeaders = () => {
		return (
			<TableRow>
				{paymentFormTableHeaders
					.filter((h) => h.show)
					.map((header) => (
						//@ts-ignore //TODO: REMOVE
						<TableColumn key={header.key}>
							<p className="text-strong text-subtle">{header.title(intl)}</p>
						</TableColumn>
					))}
			</TableRow>
		)
	}

	const renderTable = () => {
		return (
			<TableContainer>
				<StyledDataTable plain>
					<TableHeader
						style={{
							position: 'sticky',
							top: 0,
							zIndex: 1,
						}}
					>
						{renderTableHeaders()}
					</TableHeader>

					<TableBody>
						{/* TODO: Loop table rows according to some data */}
						<TableRow>
							<CreateFormGrid>
								{paymentFormTableHeaders.map((input, index) => (
									<TableColumn>
										<PaymentFormInput
											key={`${input.key as string}-${index}`} //TODO: REMOVE AS STRING
											input={input}
										/>
									</TableColumn>
								))}
							</CreateFormGrid>
						</TableRow>
						<TableRow>
							{/* TODO: ADDING ROW */}
							<TableColumn>
								<p>+</p>
							</TableColumn>
						</TableRow>
					</TableBody>
				</StyledDataTable>
			</TableContainer>
		)
	}

	const renderFormFields = () => {
		return (
			<CreateFormGrid>
				{paymentFormHeaders.map((input, index) => (
					<PaymentFormInput
						key={`${input.key as string}-${index}`} //TODO: REMOVE AS STRING
						input={input}
					/>
				))}
			</CreateFormGrid>
		)
	}

	const renderChildren = () => {
		return (
			<div
				className="margin-left--lg margin-right--lg"
				style={{ paddingBottom: 64 }}
			>
				<FormProvider {...formMethods}>
					{renderFormFields()}
					{renderTable()}
				</FormProvider>
			</div>
		)
	}

	const actions = [
		{
			id: 'dialog-cancel',
			children: intl.formatMessage({
				defaultMessage: 'Peruuta',
				description: 'Cancel button',
			}),
			onClick: onHide,
		},
		{
			id: 'dialog-ok',
			secondary: true,
			children: processing ? (
				<CircularProgress id="progress" style={{ marginTop: 0 }} />
			) : (
				intl.formatMessage({
					defaultMessage: 'Tallenna',
					description: 'Save button',
				})
			),
			onClick: onProcess,
		},
	]

	return (
		<ViiluFullPageDialog
			id="payment-dialog"
			visible
			title={intl.formatMessage({
				defaultMessage: 'Lisää suoritus',
				description: 'Title of add payment',
			})}
			toolbarStyle={{
				background: 'var(--color-primary-dark)',
				boxShadow: 'none',
			}}
			actions={actions}
			onHide={onHide}
		>
			{renderChildren()}
		</ViiluFullPageDialog>
	)
}

export default PaymentDialog
